import * as angular from 'angular';

import { DatabaseConfiguration } from '../../models';
import { IRequestService } from '../../services';

export interface IWideDatabaseService {
    isUpToDate(guid: string): angular.IPromise<boolean>;
    migrateDatabase(): angular.IPromise<string>;
    migrateDatabaseAsync(): angular.IPromise<string>;
    migrateGivenDatabaseAsync(connectionPointGuid: string): angular.IPromise<string>;
    create(model: DatabaseConfiguration): angular.IPromise<any>;
}

export class WideDatabaseService implements IWideDatabaseService {
    static serviceId = 'wideDatabaseService';

    static $inject = ['$q', 'requestService'];
    
    constructor(
        private _$q: angular.IQService,
        private _requestService: IRequestService) {
    }

    private getControllerUrl(): string {
        return this._requestService.getUrlV1() + 'database/';
    }

    isUpToDate(guid: string): angular.IPromise<boolean> {
        const url = this.getControllerUrl() + 'isUpToDate/' + guid;
        this._requestService.cleanCache(url);
        return this._requestService.get(url);
    }

    migrateDatabase(): angular.IPromise<string> {
        const url = this.getControllerUrl() + 'migrate';
        this._requestService.cleanCache(url);
        this._requestService.cleanAllCache();
        this._requestService.cleanCacheAtV1('connectionPoint/');
        return this._requestService.get(url);
    }

    migrateGivenDatabaseAsync(connectionPointGuid: string): angular.IPromise<string> {
        const url = this.getControllerUrl() + 'migrateAsync/' + connectionPointGuid;
        this._requestService.cleanCache(url);
        this._requestService.cleanCacheAtV1('connectionPoint/');
        this._requestService.cleanCacheAtV1(`connectionPoint/${connectionPointGuid}`);
        this._requestService.cleanCacheAtV1(`isUpToDate/${connectionPointGuid}`);
        this._requestService.cleanCacheAtV1('application');
        return this._requestService.get(url);
    }

    migrateDatabaseAsync(): angular.IPromise<string> {
        const url = this.getControllerUrl() + 'migrateAsync';
        this._requestService.cleanCache(url);
        this._requestService.cleanCacheAtV1('connectionPoint/');
        return this._requestService.get(url);
    }

    create(model: DatabaseConfiguration): angular.IPromise<any> {
        const deferd = this._$q.defer();
        const url = this.getControllerUrl() + 'create';
        this._requestService.post(url, model).then((data) => {
            if (model.isConnectionPointCreationRequired) {
                this._requestService.cleanCache(this._requestService.getUrlV1() + 'connectionPoint');
            }
            deferd.resolve(data);
        })
            .catch(() => { deferd.reject(); });
        return deferd.promise;
    }
}
